// extracted by mini-css-extract-plugin
module.exports = {"container":"ka","bottomGradient":"kb","image":"kc","brandLogoFrame":"kd","logoImage":"ke","logoImageFrame":"kf"};